import { combineReducers } from 'redux';
import {
    CONTAINER_SIZE_GET_LOADING,
    CONTAINER_SIZE_GET_ERROR,
    CONTAINER_SIZE_GET,
    
    CONTAINER_SIZE_ADD_LOADING,
    CONTAINER_SIZE_ADD_ERROR,
    CONTAINER_SIZE_ADD,

    CONTAINER_SIZE_UPDATE_LOADING,
    CONTAINER_SIZE_UPDATE_ERROR,
    CONTAINER_SIZE_UPDATE,

    CONTAINER_SIZE_DELETE_LOADING,
    CONTAINER_SIZE_DELETE_ERROR,
    CONTAINER_SIZE_DELETE,
} from '../actions/sizeContainerAction';


const sizeGetLoading = (state = false, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_GET_LOADING:
            return action.sizeGetLoading;
        default:
            return state;
    }
}

const sizeGetError = (state = false, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_GET_ERROR:
            return action.sizeGetError;
        default:
            return state;
    }
}

const sizeGetSuccess = (state = null, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_GET:
            return action.sizes;
        default:
            return state;
    }
}
const sizeGetSuccessBool = (state = false, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_GET:
            return action.sizeGetSuccess;
        default:
            return state;
    }
}

const sizeAddLoading = (state = false, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_ADD_LOADING:
            return action.sizeAddLoading;
        default:
            return state;
    }
}

const sizeAddError = (state = false, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_ADD_ERROR:
            return action.sizeAddError;
        default:
            return state;
    }
}

const sizeAddSuccess = (state = null, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_ADD:
            return action.size;
        default:
            return state;
    }
}
const sizeAddSuccessBool = (state = false, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_ADD:
            return action.sizeAddSuccess;
        default:
            return state;
    }
}

const sizeUpdateLoading = (state = false, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_UPDATE_LOADING:
            return action.sizeUpdateLoading;
        default:
            return state;
    }
}

const sizeUpdateError = (state = false, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_UPDATE_ERROR:
            return action.sizeUpdateError;
        default:
            return state;
    }
}

const sizeUpdateSuccess = (state = null, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_UPDATE:
            return action.size;
        default:
            return state;
    }
}

const sizeUpdateSuccessBool = (state = false, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_UPDATE:
            return action.sizeUpdateSuccess;
        default:
            return state;
    }
}

const sizeDeleteLoading = (state = false, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_DELETE_LOADING:
            return action.sizeDeleteLoading;
        default:
            return state;
    }
}

const sizeDeleteError = (state = false, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_DELETE_ERROR:
            return action.sizeDeleteError;
        default:
            return state;
    }
}

const sizeDeleteSuccess = (state = null, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_DELETE:
            return action.size;
        default:
            return state;
    }
}

const sizeDeleteSuccessBool = (state = false, action) => {
    switch (action.type) {
        case CONTAINER_SIZE_DELETE:
            return action.sizeDeleteSuccess;
        default:
            return state;
    }
}

const SizeReducer = combineReducers({
    sizeGetLoading,
    sizeGetError,
    sizeGetSuccess,
    sizeGetSuccessBool,

    sizeAddLoading,
    sizeAddError,
    sizeAddSuccess,
    sizeAddSuccessBool,

    sizeUpdateLoading,
    sizeUpdateError,
    sizeUpdateSuccess,
    sizeUpdateSuccessBool,

    sizeDeleteLoading,
    sizeDeleteError,
    sizeDeleteSuccess,
    sizeDeleteSuccessBool,
});

export default SizeReducer;

